import {getHeaderHeight} from '../layout-dynamics'
import {config} from '../../config'
import {isAppRoute} from '../app-routes'
import {is600, is1024, isMobile} from '../caps'

export const BASE_SIZE = 352
export const BASE_SIZE_HALF = BASE_SIZE * .5
export const injectBaseSize = () => {
    document.documentElement.style.setProperty('--base-size', `${BASE_SIZE}px`)
    document.documentElement.style.setProperty('--base-size-half', `${BASE_SIZE_HALF}px`)
    updateEffectiveBaseSize()
    window.addEventListener('resize', updateEffectiveBaseSize) }
function updateEffectiveBaseSize() {
    const columnCount = obtainColumnCount()
    const maxGridWidth = BASE_SIZE * columnCount
    const actualGridWidth = Math.min(window.innerWidth, maxGridWidth)
    document.documentElement.style.setProperty('--effective-base-size', `${actualGridWidth / columnCount}px`) }
export const widthToColumnCount = {600: 2, 1024: 3, 1366: 4, 1920: 5}
export const widthToMaxWidth = {600: BASE_SIZE * 2, 1024: BASE_SIZE * 3, 1366: BASE_SIZE * 4, 1920: BASE_SIZE * 5}
if (config.maxColumnCount < 5) delete widthToColumnCount[1920]
if (config.maxColumnCount < 4) delete widthToColumnCount[1366]
if (config.maxColumnCount < 3) delete widthToColumnCount[1024]
export const obtainColumnCount = (columnSplit = false) => {
    for (let width of Object.keys(widthToColumnCount).sort((a, b) => b - a))
        if (window.innerWidth >= width)
            return (columnSplit && !is600() ? 2 : 1) * widthToColumnCount[width]
    return (columnSplit && !is600() ? 2 : 1) }
export const columnWidth = (columnSplit = false) => {
    if (!is600()) return window.innerWidth * (columnSplit ? .5 : 1)
    const columnCount = obtainColumnCount(columnSplit)
    const maxGridWidth = BASE_SIZE * columnCount
    const actualGridWidth = Math.min(window.innerWidth, maxGridWidth)
    return actualGridWidth / columnCount }
export const obtainMaxWidth = () => {
    for (let width of Object.keys(widthToMaxWidth).sort((a, b) => b - a))
        if (window.innerWidth >= width)
            return widthToMaxWidth[width]
    return window.innerWidth }
export const obtainViewportHeight = (checkHeader = true) =>
    window.innerHeight - ((!is600() || !checkHeader) ? 0 : (getHeaderHeight() * 2))
export const obtainViewportWidth = () => window.innerWidth
export const getRowFromIndex = (index, columnSplit = false) => Math.floor(index / obtainColumnCount(columnSplit))
export const getColumnFromIndex = (index, columnSplit = false) => index % obtainColumnCount(columnSplit)
export const isSizePortraitRelative = (size, item) => {
    if (size?.width != null && size?.height != null)
        return size.height * (item?.horizontal ? 2 : 1) > size.width * (item?.vertical ? 2 : 1) }
export const calculateMediaDimensions = (item, scale = item.scale || 1, splitColumn = false, sizeLimit = null) => {
    const portrait = isSizePortraitRelative(item, item)
    const cellSize = (sizeLimit || columnWidth(splitColumn)) * scale
    const ratio = item.width / item.height
    const multiplier = (item.horizontal && !(!portrait && ratio > 2) || item.vertical && !(portrait && ratio < .5)) ? 2 : 1
    return { width: portrait ? cellSize * multiplier : cellSize * ratio * multiplier,
        height: portrait ? cellSize * (1 / ratio) * multiplier : cellSize * multiplier } }
export const calculateMediaDimensionsPx = (item, scale = item.scale || 1, splitColumn = false, sizeLimit = null) => {
    const dimensions = calculateMediaDimensions(item, scale, splitColumn, sizeLimit)
    return {width: `${dimensions.width}px`, height: `${dimensions.height}px`} }
export const calculateContainerDimensions = (item, splitColumn = false, sizeLimit = null) => {
    const cellSize = sizeLimit || columnWidth(splitColumn)
    const widthMultiplier = item.horizontal ? 2 : 1
    const heightMultiplier = item.vertical ? 2 : 1
    return {width: cellSize * widthMultiplier, height: cellSize * heightMultiplier} }
export const calculateDisplaySize = ({heightLimit, sizeLimit, widthLimit, item, active, forceActive, adaptHeight, sizerScale, scale, splitColumn}) => {
    const vh = heightLimit || sizeLimit || (obtainViewportHeight(!isAppRoute()) - (is1024() ? 64 : 0))
    const vw = widthLimit || sizeLimit || (Math.min(obtainMaxWidth(), obtainViewportWidth()) - (is1024() ? 64 : 0))
    const ratio = item.width / item.height
    const sizeBasedOnWidth = {width: vw, height: vw * (1/ratio)}
    const sizeBasedOnHeight = {width: vh * ratio, height: vh}
    const calculate = () =>
        calculateMediaDimensions(item, scale * (is600() ? sizerScale : 1), splitColumn, sizeLimit)
    const shouldBaseOnWidth = isMobile() ? adaptHeight : (
        sizeBasedOnWidth.width * sizeBasedOnWidth.height < sizeBasedOnHeight.width * sizeBasedOnHeight.height
    )
    const displaySize = active || forceActive ? shouldBaseOnWidth ? sizeBasedOnWidth : sizeBasedOnHeight : calculate()
    return displaySize
}
